import { ComposerPrimitive, useAui, useAuiState } from "@assistant-ui/react";
import React from "react";
import { useIntl } from "react-intl";
import { Button } from "../../button/Button";
import styles from "./AiChatInput.scss";

const msgKey = "aiChatInput";

/**
 * Chat composer: assistant-ui's composer state machine (controlled input,
 * enter-to-send, send/cancel availability) rendered with our design-system
 * Button docked inside the input container. Mounted inside
 * ThreadPrimitive.ViewportFooter by AiChatThread — the footer registers its
 * height with the viewport so anchored/following scroll accounts for it.
 */
export const AiChatInput = () => {
    const intl = useIntl();
    const aui = useAui();
    const canSend = useAuiState((state) => state.composer.canSend);
    const isRunning = useAuiState((state) => state.thread.isRunning);

    return (
        <ComposerPrimitive.Root className={styles.form}>
            <div className={styles.shell}>
                <ComposerPrimitive.Input
                    className={styles.input}
                    placeholder={intl.formatMessage({ id: `${msgKey}.placeholder` })}
                />
                {isRunning ? (
                    <Button
                        color="default"
                        circle
                        size="small"
                        icon="stop"
                        title={intl.formatMessage({ id: `${msgKey}.stop` })}
                        onClick={() => aui.composer.cancel()}
                    />
                ) : (
                    <Button
                        color="primary"
                        circle
                        size="small"
                        icon="arrow-up"
                        type="submit"
                        title={intl.formatMessage({ id: `${msgKey}.send` })}
                        disabled={!canSend}
                    />
                )}
            </div>
        </ComposerPrimitive.Root>
    );
};
